import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { clearCart as clearCartUtil, getCart as getCartUtil, addToCart as addToCartUtil, saveCart as saveCartUtil } from '../utils/cart'
import { useAuth } from '../AuthContext'
import { toast } from '../lib/toastWrapper'
import { C, s } from '../styles/tokens'
import { API_BASE } from '../config'
import { isRx, prescriptionCovers } from '../utils/rx'
import { isServiceable, DEFAULT_COUNTRY } from '../config/regions'

const STEPS = ['Cart', 'Address', 'Payment', 'Confirmation']

const STATES = ['Andhra Pradesh','Assam','Bihar','Delhi','Goa','Gujarat','Haryana','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Odisha','Punjab','Rajasthan','Tamil Nadu','Telangana','Uttar Pradesh','West Bengal']

// Trim the wide white canvas around product photos so thumbnails fill the frame
const cld = (url, size = 180) => (url && url.includes('/upload/')) ? url.replace('/upload/', `/upload/e_trim/c_pad,b_white,w_${size},h_${size},q_auto,f_auto/`) : url
const _RXM = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
const fmtD = d => { try { const x = new Date(d); return `${x.getDate()} ${_RXM[x.getMonth()]}` } catch { return '' } }

/* ── Stepper ── */
function Stepper({ step, narrow }) {
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:0, marginBottom:'2rem' }}>
      {STEPS.map((label, i) => (
        <React.Fragment key={label}>
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:4 }}>
            <div style={{
              width:32, height:32, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:'.78rem', fontWeight:700,
              background: i < step ? C.g700 : i === step ? C.g900 : '#E5E7EB',
              color: i <= step ? 'white' : C.muted,
            }}>
              {i < step ? '✓' : i+1}
            </div>
            <span style={{ fontSize:'.68rem', fontWeight: i === step ? 700 : 400, color: i === step ? C.g900 : C.muted, whiteSpace:'nowrap' }}>{label}</span>
          </div>
          {i < STEPS.length-1 && (
            <div style={{ height:2, width: narrow ? 22 : 60, background: i < step ? C.g700 : '#E5E7EB', marginBottom:18 }} />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

/* ── Cart Step ── */
function CartStep({ cart, updateQty, removeItem, coupon, setCoupon, couponApplied, applyCoupon, navigate }) {
  return (
    <div>
      <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.4rem', color:C.g900, marginBottom:'1rem' }}>
        Your Cart ({cart.length} item{cart.length !== 1 ? 's' : ''})
      </h2>
      {cart.length === 0 ? (
        <div style={{ textAlign:'center', padding:'4rem 1rem', color:C.muted }}>
          <div style={{ fontSize:'3rem', marginBottom:'1rem', opacity:.2 }}>🛒</div>
          <div style={{ fontWeight:600, marginBottom:'.75rem', color:C.g900 }}>Your cart is empty</div>
          <button onClick={() => navigate('/shop')} style={{ ...s.btnPrimary, display:'inline-block' }}>Browse Products</button>
        </div>
      ) : (
        cart.map((item, idx) => (
          <div key={idx} style={{ display:'flex', gap:12, padding:'.85rem', background:'white', border:`1px solid ${C.border}`, borderRadius:14, marginBottom:'.6rem' }}>
            <div style={{ width:66, height:66, background:'#fff', borderRadius:12, overflow:'hidden', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', border:`1px solid ${C.border}` }}>
              {item.imgs?.[0]
                ? <img src={cld(item.imgs[0], 200)} alt={item.name} style={{ width:'100%', height:'100%', objectFit:'contain', padding:5 }} />
                : <span style={{ fontSize:'1.8rem', opacity:.1 }}>🧴</span>}
            </div>
            <div style={{ flex:1, minWidth:0, display:'flex', flexDirection:'column' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8 }}>
                <div style={{ minWidth:0 }}>
                  <div style={{ fontSize:'.62rem', color:C.muted, textTransform:'uppercase', letterSpacing:'.06em' }}>{item.brand}</div>
                  <div style={{ fontWeight:600, color:C.g900, fontSize:'.84rem', lineHeight:1.3, marginTop:1, display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>{item.name}</div>
                  {isRx(item) && <span style={{ display:'inline-block', fontSize:'.54rem', fontWeight:700, color:'#B7770D', background:'#FFF8E1', border:'1px solid #FFE082', borderRadius:6, padding:'.1rem .4rem', marginTop:3 }}>℞ Prescription</span>}
                </div>
                <button onClick={() => removeItem(idx)} aria-label="Remove" style={{ background:'none', border:'none', color:C.muted, cursor:'pointer', fontSize:'1.05rem', padding:2, flexShrink:0, lineHeight:1 }}>✕</button>
              </div>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'auto', paddingTop:8 }}>
                <div style={{ display:'inline-flex', alignItems:'center', border:`1.5px solid ${C.border}`, borderRadius:999, overflow:'hidden' }}>
                  <button onClick={() => updateQty(idx, (item.quantity||1)-1)} style={{ width:30, height:30, border:'none', background:'white', cursor:'pointer', fontSize:'1.05rem', color:C.g700 }}>−</button>
                  <span style={{ minWidth:26, textAlign:'center', fontSize:'.85rem', fontWeight:700, color:C.g900 }}>{item.quantity||1}</span>
                  <button onClick={() => updateQty(idx, (item.quantity||1)+1)} style={{ width:30, height:30, border:'none', background:'white', cursor:'pointer', fontSize:'1rem', color:C.g700 }}>+</button>
                </div>
                <div style={{ textAlign:'right' }}>
                  <div style={{ fontWeight:800, color:C.g900, fontSize:'.95rem' }}>₹{(item.price||0)*(item.quantity||1)}</div>
                  {(item.quantity||1) > 1 && <div style={{ fontSize:'.64rem', color:C.muted }}>₹{item.price} each</div>}
                </div>
              </div>
            </div>
          </div>
        ))
      )}
      {cart.length > 0 && (
        <div style={{ display:'flex', gap:'.5rem', marginTop:'.7rem' }}>
          <input value={coupon} onChange={e => setCoupon(e.target.value)} placeholder="Coupon code (try REVIVE10)"
            style={{ flex:1, padding:'.75rem 1rem', border:`1.5px solid ${C.border}`, borderRadius:10, fontSize:'.85rem', outline:'none', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }} />
          <button onClick={applyCoupon}
            style={{ padding:'.75rem 1.25rem', background: couponApplied ? C.g600 : C.g900, color:'white', border:'none', borderRadius:10, fontSize:'.85rem', fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", flexShrink:0 }}>
            {couponApplied ? '✓ Applied' : 'Apply'}
          </button>
        </div>
      )}
    </div>
  )
}

/* ── Address Step ── */
function AddressStep({ addr, setAddr, addresses = [], selectedId, editing, saving, onSelect, onNew, onEdit, onDelete, onSave, onCancel }) {
  const [pincodeStatus, setPincodeStatus] = React.useState('')
  const fmtLine = a => [a.flat, a.area, a.city, a.state, a.pincode].filter(Boolean).join(', ')
  const TYPE_ICON = { Home: '🏠', Work: '🏢', Other: '📍' }

  // Saved-address picker (shown when the user has addresses and isn't editing)
  if (addresses.length > 0 && !editing) {
    return (
      <div>
        <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.4rem', color:C.g900, marginBottom:'1.1rem' }}>Delivery Address</h2>
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {addresses.map(a => (
            <div key={a.id} onClick={() => onSelect(a)}
              style={{ border:`1.5px solid ${selectedId===a.id ? C.g700 : C.border}`, background: selectedId===a.id ? C.g50 : '#fff', borderRadius:12, padding:'.9rem 1rem', cursor:'pointer' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8 }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, minWidth:0 }}>
                  <span style={{ width:16, height:16, borderRadius:'50%', border:`2px solid ${selectedId===a.id ? C.g700 : C.border}`, background: selectedId===a.id ? C.g700 : '#fff', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {selectedId===a.id && <span style={{ width:6, height:6, borderRadius:'50%', background:'#fff' }} />}
                  </span>
                  <span style={{ fontSize:'.72rem', fontWeight:700, color:C.g700 }}>{TYPE_ICON[a.type]||'📍'} {a.type}</span>
                  {a.isDefault ? <span style={{ fontSize:'.6rem', fontWeight:700, color:C.g700, background:C.g100, borderRadius:999, padding:'.1rem .5rem' }}>DEFAULT</span> : null}
                </div>
                <div style={{ display:'flex', gap:12, flexShrink:0 }}>
                  <button onClick={e => { e.stopPropagation(); onEdit(a) }} style={{ background:'none', border:'none', color:C.g700, fontSize:'.74rem', fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Edit</button>
                  <button onClick={e => { e.stopPropagation(); onDelete(a) }} style={{ background:'none', border:'none', color:'#C0392B', fontSize:'.74rem', fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Delete</button>
                </div>
              </div>
              <div style={{ marginTop:6, fontWeight:700, color:C.g900, fontSize:'.86rem' }}>{a.name} · {a.phone}</div>
              <div style={{ fontSize:'.8rem', color:C.muted, marginTop:2, lineHeight:1.4 }}>{fmtLine(a)}</div>
            </div>
          ))}
        </div>
        <button onClick={onNew} style={{ marginTop:12, width:'100%', background:'#fff', color:C.g700, border:`1.5px dashed ${C.g500}`, borderRadius:12, padding:'.85rem', fontWeight:700, fontSize:'.85rem', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>＋ Add a new address</button>
      </div>
    )
  }

  const lookupPincode = async (pin) => {
    if (pin.length !== 6) return
    setPincodeStatus('checking')
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`)
      const data = await res.json()
      if (data[0]?.Status === 'Success' && data[0].PostOffice?.length) {
        const po = data[0].PostOffice[0]
        setAddr(a => ({ ...a, city: po.District, state: po.State }))
        setPincodeStatus('found')
      } else {
        setPincodeStatus('not_found')
      }
    } catch {
      setPincodeStatus('error')
    }
  }

  return (
    <div>
      <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.4rem', color:C.g900, marginBottom:'1.25rem' }}>Delivery Address</h2>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'.85rem' }}>
        {/* Full Name */}
        <div style={{ gridColumn:'span 2' }}>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.35rem' }}>Full Name</label>
          <input value={addr.name} onChange={e => setAddr(a => ({ ...a, name: e.target.value }))} placeholder="Enter your full name"
            style={{ width:'100%', padding:'.7rem .9rem', border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:'.875rem', outline:'none', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }} />
        </div>
        {/* Phone */}
        <div>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.35rem' }}>Phone Number</label>
          <input type="tel" value={addr.phone} onChange={e => setAddr(a => ({ ...a, phone: e.target.value }))} placeholder="+91 XXXXX XXXXX"
            style={{ width:'100%', padding:'.7rem .9rem', border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:'.875rem', outline:'none', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }} />
        </div>
        {/* Pincode */}
        <div>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.35rem' }}>Pincode</label>
          <div style={{ position:'relative' }}>
            <input
              value={addr.pincode}
              onChange={e => {
                const pin = e.target.value.replace(/\D/g,'').slice(0,6)
                setAddr(a => ({ ...a, pincode: pin }))
                setPincodeStatus('')
                if (pin.length === 6) lookupPincode(pin)
              }}
              placeholder="6-digit pincode"
              style={{ width:'100%', padding:'.7rem .9rem', border:`1.5px solid ${pincodeStatus==='found' ? C.g600 : pincodeStatus==='not_found' ? '#EF4444' : C.border}`, borderRadius:9, fontSize:'.875rem', outline:'none', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box', paddingRight:'2.5rem' }} />
            {pincodeStatus === 'checking' && (
              <span style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', width:14, height:14, border:'2px solid #D1D5DB', borderTopColor:C.g600, borderRadius:'50%', animation:'spin 1s linear infinite', display:'inline-block' }} />
            )}
            {pincodeStatus === 'found' && <span style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', color:C.g600, fontSize:'.9rem' }}>✓</span>}
            {pincodeStatus === 'not_found' && <span style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', color:'#EF4444', fontSize:'.9rem' }}>✕</span>}
          </div>
          {pincodeStatus === 'not_found' && <div style={{ fontSize:'.7rem', color:'#EF4444', marginTop:3 }}>Pincode not found</div>}
          {String(addr.pincode || '').length === 6 && pincodeStatus !== 'not_found' && (
            isServiceable(DEFAULT_COUNTRY, addr.pincode)
              ? <div style={{ fontSize:'.7rem', color:C.g600, marginTop:3 }}>✓ We deliver to your area</div>
              : <div style={{ fontSize:'.7rem', color:'#C0392B', marginTop:3 }}>We don't deliver to this area yet</div>
          )}
        </div>
        {/* Flat */}
        <div style={{ gridColumn:'span 2' }}>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.35rem' }}>Flat / House No. / Building</label>
          <input value={addr.flat} onChange={e => setAddr(a => ({ ...a, flat: e.target.value }))} placeholder="Flat no., building name"
            style={{ width:'100%', padding:'.7rem .9rem', border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:'.875rem', outline:'none', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }} />
        </div>
        {/* Area */}
        <div style={{ gridColumn:'span 2' }}>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.35rem' }}>Area / Street / Locality</label>
          <input value={addr.area} onChange={e => setAddr(a => ({ ...a, area: e.target.value }))} placeholder="Street address, area"
            style={{ width:'100%', padding:'.7rem .9rem', border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:'.875rem', outline:'none', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }} />
        </div>
        {/* City */}
        <div>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.35rem' }}>City</label>
          <input value={addr.city} onChange={e => setAddr(a => ({ ...a, city: e.target.value }))} placeholder="City"
            style={{ width:'100%', padding:'.7rem .9rem', border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:'.875rem', outline:'none', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box' }} />
        </div>
        {/* State */}
        <div>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.35rem' }}>State</label>
          <select value={addr.state} onChange={e => setAddr(a => ({ ...a, state: e.target.value }))}
            style={{ width:'100%', padding:'.7rem .9rem', border:`1.5px solid ${C.border}`, borderRadius:9, fontSize:'.875rem', outline:'none', background:'white', fontFamily:"'DM Sans',sans-serif", boxSizing:'border-box', color:C.text }}>
            {STATES.map(st => <option key={st}>{st}</option>)}
          </select>
        </div>
        {/* Address Type */}
        <div style={{ gridColumn:'span 2' }}>
          <label style={{ display:'block', fontSize:'.72rem', fontWeight:600, color:C.muted, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:'.5rem' }}>Address Type</label>
          <div style={{ display:'flex', gap:'.75rem' }}>
            {[['Home','🏠'],['Work','🏢'],['Other','📍']].map(([t,icon]) => (
              <button key={t} onClick={() => setAddr(a => ({ ...a, type: t }))}
                style={{ padding:'.5rem 1.25rem', border:`1.5px solid ${addr.type===t ? C.g700 : C.border}`, borderRadius:8, background: addr.type===t ? C.g50 : 'white', color: addr.type===t ? C.g700 : C.muted, fontSize:'.82rem', fontWeight: addr.type===t ? 700 : 400, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                {icon} {t}
              </button>
            ))}
          </div>
        </div>
        {/* Set as default */}
        <label style={{ gridColumn:'span 2', display:'flex', alignItems:'center', gap:8, fontSize:'.8rem', color:C.text, cursor:'pointer' }}>
          <input type="checkbox" checked={!!addr.isDefault} onChange={e => setAddr(a => ({ ...a, isDefault: e.target.checked ? 1 : 0 }))} />
          Make this my default delivery address
        </label>
      </div>
      <div style={{ display:'flex', gap:10, marginTop:16 }}>
        <button onClick={onSave} disabled={saving}
          style={{ flex:1, background: saving ? '#D1D5DB' : C.g700, color:'#fff', border:'none', borderRadius:12, padding:'.85rem', fontWeight:800, fontSize:'.88rem', cursor: saving ? 'default' : 'pointer', fontFamily:"'DM Sans',sans-serif" }}>
          {saving ? 'Saving…' : 'Save & Continue →'}
        </button>
        {addresses.length > 0 && (
          <button onClick={onCancel} style={{ padding:'.85rem 1.4rem', background:'#fff', color:C.g900, border:`1.5px solid ${C.border}`, borderRadius:12, fontWeight:700, fontSize:'.85rem', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancel</button>
        )}
      </div>
    </div>
  )
}

/* ── Payment Step ── */
function PaymentStep({ payMethod, setPayMethod }) {
  return (
    <div>
      <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.4rem', color:C.g900, marginBottom:'1.25rem' }}>Payment Method</h2>
      <div style={{ display:'flex', flexDirection:'column', gap:'.65rem' }}>
        {[
          { id:'upi',        icon:'📱', label:'UPI / GPay / PhonePe', sub:'Instant. Zero charges.' },
          { id:'card',       icon:'💳', label:'Credit / Debit Card',  sub:'Visa, Mastercard, Rupay' },
          { id:'netbanking', icon:'🏦', label:'Net Banking',          sub:'All major banks' },
          { id:'emi',        icon:'📅', label:'EMI (No-Cost)',        sub:'0% interest up to 3 months' },
        ].map(m => (
          <button key={m.id} onClick={() => setPayMethod(m.id)}
            style={{ display:'flex', alignItems:'center', gap:'1rem', padding:'1rem 1.25rem', border:`1.5px solid ${payMethod===m.id ? C.g700 : C.border}`, borderRadius:11, background: payMethod===m.id ? C.g50 : 'white', cursor:'pointer', textAlign:'left' }}>
            <span style={{ fontSize:'1.4rem', flexShrink:0 }}>{m.icon}</span>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:'.88rem', fontWeight:700, color:C.g900 }}>{m.label}</div>
              <div style={{ fontSize:'.75rem', color:C.muted, marginTop:2 }}>{m.sub}</div>
            </div>
            <div style={{ width:18, height:18, borderRadius:'50%', border:`2px solid ${payMethod===m.id ? C.g700 : C.border}`, background: payMethod===m.id ? C.g700 : 'white', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
              {payMethod===m.id && <div style={{ width:8, height:8, borderRadius:'50%', background:'white' }}/>}
            </div>
          </button>
        ))}
      </div>
      <div style={{ marginTop:'1rem', display:'flex', alignItems:'flex-start', gap:8, padding:'.85rem 1rem', background:C.g50, border:`1px solid ${C.border}`, borderRadius:10, fontSize:'.76rem', color:C.muted, lineHeight:1.5 }}>
        <span>🔒</span>
        <span>You'll complete payment securely on the next screen. Enter your UPI ID / card / bank details there — we never store them.</span>
      </div>
    </div>
  )
}

/* ── Order Confirmed ── */
function OrderConfirmed({ navigate, hadRx }) {
  return (
    <div style={{ minHeight:'60vh', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ textAlign:'center', maxWidth:440, padding:'3rem 2rem' }}>
        <div style={{ width:80, height:80, borderRadius:'50%', background:C.g100, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'2.5rem', margin:'0 auto 1.5rem' }}>✅</div>
        <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.8rem', color:C.g900, marginBottom:'.75rem' }}>Order Placed!</h2>
        <p style={{ color:C.muted, lineHeight:1.8, fontSize:'.9rem', marginBottom: hadRx ? '1rem' : '1.75rem' }}>
          Thank you for your order! We've saved it — track it anytime in Profile → My Orders, and we'll notify you in the app as it progresses. Expected delivery in 2–4 business days.
        </p>
        {hadRx && (
          <div style={{ background:'#FFF8E1', border:'1px solid #FFE082', borderRadius:12, padding:'.9rem 1.1rem', marginBottom:'1.75rem', textAlign:'left', display:'flex', gap:9 }}>
            <span style={{ fontSize:'1.1rem' }}>℞</span>
            <div style={{ fontSize:'.78rem', color:'#7a5b12', lineHeight:1.5 }}>Your order includes prescription medicine. A <b>licensed pharmacist will verify your prescription</b> before it's dispatched — we may contact you if anything is needed.</div>
          </div>
        )}
        <div style={{ display:'flex', gap:'.75rem', justifyContent:'center', flexWrap:'wrap' }}>
          <button onClick={() => navigate('/')} style={{ ...s.btnPrimary }}>Back to Home</button>
          <button onClick={() => navigate('/shop')} style={{ padding:'.75rem 1.5rem', borderRadius:10, background:'white', color:C.g900, border:`1.5px solid ${C.g900}`, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontSize:'.9rem' }}>
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  )
}

/* ══════════════════════════════════════
   Main CheckoutPage
══════════════════════════════════════ */
export default function CheckoutPage({ onClear, onAdd, onBuy }) {
  const loc = useLocation()
  const navigate = useNavigate()
  const { user, fetchWithAuth } = useAuth()
  // Responsive: stack the order-summary under the form on narrow (mobile) screens
  const [narrow, setNarrow] = React.useState(typeof window !== 'undefined' && window.innerWidth < 760)
  React.useEffect(() => {
    const fn = () => setNarrow(window.innerWidth < 760)
    window.addEventListener('resize', fn); return () => window.removeEventListener('resize', fn)
  }, [])
  const patientId = loc.state?.patientId || loc.state?.patientEmail || (user?.role === 'patient' ? user?.email : undefined)

  // Redirect to login if not logged in as patient
  React.useEffect(() => {
    if (!user || user.role !== 'patient') {
      navigate('/login?redirect=/checkout')
    }
  }, [user, navigate])

  const [cart, setCart] = React.useState(() => {
    if (loc.state?.cart?.length) return loc.state.cart
    // try patient-scoped cart first, fall back to global cart
    const scoped = getCartUtil(patientId)
    if (scoped?.length) return scoped
    return getCartUtil(null)   // global (pre-login) cart
  })
  const [step, setStep]             = React.useState(0)
  const [processing, setProcessing] = React.useState(false)
  const [coupon, setCoupon]         = React.useState('')
  const [couponApplied, setCouponApplied] = React.useState(false)
  const [couponPct, setCouponPct] = React.useState(10)
  const [addr, setAddr] = React.useState(() => {
    try {
      const saved = localStorage.getItem('revive_addr')
      return saved ? JSON.parse(saved) : { name:'', phone:'', pincode:'', flat:'', area:'', city:'', state:'Tamil Nadu', type:'Home' }
    } catch { return { name:'', phone:'', pincode:'', flat:'', area:'', city:'', state:'Tamil Nadu', type:'Home' } }
  })
  const [payMethod, setPayMethod]   = React.useState('upi')

  // Persist address to localStorage whenever it changes
  React.useEffect(() => {
    try { localStorage.setItem('revive_addr', JSON.stringify(addr)) } catch {}
  }, [addr])

  // Jump to top when moving between steps (so Continue clearly lands on the next step)
  React.useEffect(() => { window.scrollTo(0, 0) }, [step])

  // Prefill name/phone from the logged-in profile — once, without clobbering edits
  const prefilled = React.useRef(false)
  React.useEffect(() => {
    if (prefilled.current || !user) return
    prefilled.current = true
    const idIsPhone = user.email && !String(user.email).includes('@') && (String(user.email).match(/\d/g) || []).length >= 7
    setAddr(a => ({
      ...a,
      name: a.name || user.name || '',
      phone: a.phone || user.phone || (idIsPhone ? user.email : ''),
    }))
  }, [user])

  // ── Saved address book (synced to the account) ──
  const [addresses, setAddresses] = React.useState([])
  const [selectedAddrId, setSelectedAddrId] = React.useState(null)
  const [editingAddr, setEditingAddr] = React.useState(false)
  const [savingAddr, setSavingAddr] = React.useState(false)

  const fetchAddresses = React.useCallback(async () => {
    try {
      const res = await fetchWithAuth(`${API_BASE}/api/addresses`)
      if (!res.ok) return []
      const j = await res.json()
      return j.addresses || []
    } catch { return [] }
  }, [fetchWithAuth])

  React.useEffect(() => {
    if (!user) return
    let alive = true
    fetchAddresses().then(list => {
      if (!alive) return
      setAddresses(list)
      if (list.length) {
        const def = list.find(a => a.isDefault) || list[0]
        setSelectedAddrId(def.id); setAddr(def); setEditingAddr(false)
      } else {
        setEditingAddr(true); setSelectedAddrId('new')
      }
    })
    return () => { alive = false }
  }, [user, fetchAddresses])

  const selectAddress = (a) => { setSelectedAddrId(a.id); setAddr(a); setEditingAddr(false) }
  const newAddress = () => {
    const idIsPhone = user?.email && !String(user.email).includes('@') && (String(user.email).match(/\d/g) || []).length >= 7
    setSelectedAddrId('new')
    setAddr({ name: user?.name || '', phone: user?.phone || (idIsPhone ? user.email : ''), pincode: '', flat: '', area: '', city: '', state: 'Tamil Nadu', type: 'Home' })
    setEditingAddr(true)
  }
  const editAddress = (a) => { setSelectedAddrId(a.id); setAddr(a); setEditingAddr(true) }
  const cancelEdit = () => {
    if (addresses.length) { const a = addresses.find(x => x.id === selectedAddrId) || addresses.find(x => x.isDefault) || addresses[0]; selectAddress(a) }
  }
  const deleteAddress = async (a) => {
    try { await fetchWithAuth(`${API_BASE}/api/addresses/${a.id}`, { method: 'DELETE' }) } catch {}
    const list = await fetchAddresses()
    setAddresses(list)
    if (selectedAddrId === a.id) {
      if (list.length) selectAddress(list.find(x => x.isDefault) || list[0]); else newAddress()
    }
  }
  const saveAddress = async () => {
    if (!(addr.name && addr.phone && addr.pincode && addr.flat && addr.city)) {
      try { toast.error('Please fill name, phone, pincode, flat & city') } catch {}
      return
    }
    setSavingAddr(true)
    try {
      const isEdit = selectedAddrId && selectedAddrId !== 'new'
      const url = isEdit ? `${API_BASE}/api/addresses/${selectedAddrId}` : `${API_BASE}/api/addresses`
      const res = await fetchWithAuth(url, { method: isEdit ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(addr) })
      if (!res.ok) { try { toast.error('Could not save address') } catch {}; return }
      const j = await res.json()
      const list = await fetchAddresses()
      setAddresses(list)
      const saved = list.find(a => a.id === (j.id || selectedAddrId)) || list[0]
      if (saved) { setSelectedAddrId(saved.id); setAddr(saved) }
      setEditingAddr(false)
      try { toast.success('Address saved') } catch {}
      if (step === 1) setStep(2)   // saving an address on the address step = proceed to payment
    } catch { try { toast.error('Could not save address') } catch {} }
    finally { setSavingAddr(false) }
  }

  // Prescription (Schedule-H) items in the cart must have a prescription before checkout
  const rxItems = React.useMemo(() => cart.filter(isRx), [cart])

  // Pull the patient's prescriptions (from Revive consults + uploads) to auto-link
  const [rxScripts, setRxScripts] = React.useState([])   // [{ text, doctor, date, source }]
  const [rxUploading, setRxUploading] = React.useState(false)
  const [rxUploaded, setRxUploaded] = React.useState(false)
  const loadRxScripts = React.useCallback(async () => {
    if (!fetchWithAuth || !user?.email) return
    const out = []
    try {
      const r = await fetchWithAuth(`${API_BASE}/api/followups?email=${encodeURIComponent(user.email)}`)
      if (r.ok) { const j = await r.json(); (j.followups || []).forEach(a => { const t = [a.medication, a.prescription].filter(Boolean).join(' '); if (t) out.push({ text: t, doctor: a.doctor || 'Your dermatologist', date: a.date, source: 'consult' }) }) }
    } catch {}
    try {
      const r = await fetchWithAuth(`${API_BASE}/api/prescriptions`)
      if (r.ok) { const j = await r.json(); (j.prescriptions || []).forEach(p => { const t = p.medicationText || p.rawOcrText || ''; if (t) out.push({ text: t, doctor: p.doctorName || 'Uploaded prescription', date: p.createdAt, source: 'upload' }) }) }
    } catch {}
    setRxScripts(out)
  }, [fetchWithAuth, user])
  React.useEffect(() => { if (rxItems.length) loadRxScripts() }, [loadRxScripts, rxItems.length])

  const handleRxUpload = async (e) => {
    const file = e.target.files && e.target.files[0]
    if (!file) return
    setRxUploading(true)
    try {
      const fd = new FormData(); fd.append('prescription', file)
      const r = await fetchWithAuth(`${API_BASE}/api/prescriptions/scan`, { method: 'POST', body: fd })
      if (r.ok) { setRxUploaded(true); await loadRxScripts(); try { toast.success('Prescription uploaded') } catch {} }
      else { try { toast.error('Upload failed — please try again') } catch {} }
    } catch { try { toast.error('Upload failed — please try again') } catch {} }
    setRxUploading(false)
  }

  // Match each Rx item to a prescription on file
  const rxMatch = React.useMemo(() => rxItems.map(item => ({
    item, script: rxScripts.find(s => prescriptionCovers(item, s.text)) || null,
  })), [rxItems, rxScripts])
  const rxAllMatched = rxMatch.length > 0 && rxMatch.every(m => m.script)

  const subtotal  = cart.reduce((s, it) => s + ((it.price||0) * (it.quantity||1)), 0)
  const shipping  = subtotal >= 499 ? 0 : 49
  const discount  = couponApplied ? Math.round(subtotal * (couponPct || 10) / 100) : 0
  const total     = subtotal + shipping - discount

  // Keep every scope in sync so the badge and a re-opened checkout match
  const persistCart = (next) => { try { saveCartUtil(next); if (patientId) saveCartUtil(next, patientId) } catch {} }

  const updateQty = (idx, qty) => {
    if (qty < 1) { removeItem(idx); return }
    setCart(prev => { const next = prev.map((it, i) => i === idx ? { ...it, quantity: Math.min(10, qty) } : it); persistCart(next); return next })
  }

  const removeItem = (idx) => {
    setCart(prev => { const next = prev.filter((_, i) => i !== idx); persistCart(next); return next })
    try { toast.info('Removed from cart') } catch(e) {}
  }

  const applyCoupon = async () => {
    const code = coupon.trim().toUpperCase()
    if (!code) return
    try {
      const r = await fetchWithAuth(`${API_BASE}/api/coupon/validate`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code }),
      })
      const d = await r.json()
      if (d.valid) { setCouponApplied(true); setCouponPct(d.percentOff || 10); try { toast.success(`Coupon applied! ${d.percentOff || 10}% off`) } catch(e) {} }
      else { setCouponApplied(false); try { toast.error(d.reason === 'used' ? 'Coupon already used' : d.reason === 'not-yours' ? 'This coupon is for a different account' : 'Invalid coupon code') } catch(e) {} }
    } catch { try { toast.error('Could not check coupon — try again') } catch(e) {} }
  }

  const loadRazorpay = () => new Promise(resolve => {
    if (window.Razorpay) { resolve(true); return }
    const script = document.createElement('script')
    script.src = 'https://checkout.razorpay.com/v1/checkout.js'
    script.onload = () => resolve(true)
    script.onerror = () => resolve(false)
    document.body.appendChild(script)
  })

  const confirmOrder = async () => {
    setProcessing(true)
    const loaded = await loadRazorpay()
    if (!loaded) {
      alert('Razorpay failed to load. Check your internet connection.')
      setProcessing(false)
      return
    }

    const rzpKey = process.env.REACT_APP_RAZORPAY_KEY_ID
    if (!rzpKey || rzpKey.includes('PASTE_YOUR_KEY')) {
      alert('Razorpay key not configured.\n\nGo to dashboard.razorpay.com → Settings → API Keys → Generate Test Key, then paste it in frontend/.env as REACT_APP_RAZORPAY_KEY_ID and restart the dev server.')
      setProcessing(false)
      return
    }

    const options = {
      key: rzpKey,
      amount: total * 100,          // in paise
      currency: 'INR',
      name: 'Revive Skin & Hair',
      description: `Order (${cart.length} item${cart.length > 1 ? 's' : ''})`,
      image: '/logo192.png',
      prefill: {
        name: addr.name,
        contact: addr.phone,
        email: user?.email || '',
      },
      notes: {
        address: `${addr.flat}, ${addr.area}, ${addr.city}, ${addr.state} - ${addr.pincode}`,
        rx_verification: rxItems.length ? 'PENDING_PHARMACY_VERIFICATION' : 'none',
        rx_items: rxItems.length ? rxItems.map(i => i.name).join('; ').slice(0, 480) : '',
      },
      theme: { color: '#0D2218' },
      handler: async (response) => {
        // Persist the order server-side before clearing the cart
        try {
          await fetchWithAuth(`${API_BASE}/api/orders`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: cart.map(i => ({ id: i.id, name: i.name, price: i.price, quantity: i.quantity || 1 })),
              amount: total, currency: 'INR', address: addr,
              paymentId: response.razorpay_payment_id, paymentStatus: 'paid',
              rxItems: rxItems.map(i => i.name),
              rxPrescriptions: rxMatch.map(m => ({ item: m.item.name, matched: !!m.script, doctor: m.script?.doctor || null, source: m.script?.source || (rxUploaded ? 'uploaded_unmatched' : null), date: m.script?.date || null })),
            }),
          })
        } catch {}
        if (couponApplied && coupon.trim()) {
          try { await fetchWithAuth(`${API_BASE}/api/coupon/redeem`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code: coupon.trim().toUpperCase() }) }) } catch {}
        }
        clearCartUtil(patientId)
        if (onClear) onClear()
        setProcessing(false)
        setStep(3)
      },
      modal: {
        ondismiss: () => {
          setProcessing(false)
        }
      }
    }

    // Surface the method the user picked in-app first on the Razorpay screen.
    // NOTE: a method only appears if it's ENABLED on your Razorpay account
    // (e.g. UPI must be turned on in Razorpay Dashboard → Payment Methods).
    const methodBlock = { upi: 'upi', card: 'card', netbanking: 'netbanking' }[payMethod]
    if (methodBlock) {
      options.config = {
        display: {
          blocks: { preferred: { name: 'Recommended', instruments: [{ method: methodBlock }] } },
          sequence: ['block.preferred'],
          preferences: { show_default_blocks: true },
        },
      }
    }

    const rzp = new window.Razorpay(options)
    rzp.on('payment.failed', (resp) => {
      alert(`Payment failed: ${resp.error.description}`)
      setProcessing(false)
    })
    rzp.open()
  }

  const canProceed = step === 0 ? (cart.length > 0 && (rxItems.length === 0 || rxAllMatched || rxUploaded))
    : step === 1 ? (!!selectedAddrId && selectedAddrId !== 'new' && !editingAddr)
    : true

  if (step === 3) return <OrderConfirmed navigate={navigate} hadRx={rxItems.length > 0} />

  return (
    <div style={{ background:'#F9FAFB', minHeight:'100vh' }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>

      {/* Top bar */}
      <div style={{ background:'white', borderBottom:`1px solid ${C.border}`, padding: narrow ? '2.6rem 1.1rem .9rem' : '1rem 2rem', display:'flex', alignItems:'center', gap:12, position: narrow ? 'sticky' : 'static', top:0, zIndex:10 }}>
        <button onClick={() => navigate(-1)} style={{ background:'none', border:'none', cursor:'pointer', color:C.g900, fontSize: narrow ? '1.6rem' : '1.1rem', padding:'.2rem', lineHeight:1 }}>‹</button>
        <span style={{ fontFamily:"'DM Serif Display',serif", fontSize: narrow ? '1.35rem' : '1.1rem', color:C.g900, fontWeight:600 }}>Checkout</span>
      </div>

      <div style={{ ...s.inner, padding: narrow ? '1rem 1rem 110px' : '2rem', display:'grid', gridTemplateColumns: narrow ? '1fr' : '1fr 360px', gap: narrow ? '1.2rem' : '2rem', alignItems:'start' }}>

        {/* Left panel */}
        <div style={{ background: narrow ? 'transparent' : 'white', borderRadius: narrow ? 0 : 14, border: narrow ? 'none' : `1px solid ${C.border}`, padding: narrow ? 0 : '2rem' }}>
          <Stepper step={step} narrow={narrow} />

          {step === 0 && (
            <>
              <CartStep
                cart={cart} updateQty={updateQty} removeItem={removeItem}
                coupon={coupon} setCoupon={setCoupon} couponApplied={couponApplied} applyCoupon={applyCoupon}
                navigate={navigate}
              />
              {rxItems.length > 0 && (
                <div style={{ marginTop:14, background: rxAllMatched ? '#EDF7EE' : '#FFF8E1', border:`1px solid ${rxAllMatched ? '#B6DDB9' : '#FFE082'}`, borderRadius:12, padding:'1rem 1.1rem' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
                    <span style={{ fontSize:'1.1rem' }}>℞</span>
                    <div style={{ fontWeight:800, color: rxAllMatched ? '#2E6B3A' : '#7a5b12', fontSize:'.9rem' }}>{rxAllMatched ? 'Prescription on file' : 'Prescription required'}</div>
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                    {rxMatch.map(({ item, script }, i) => (
                      <div key={i} style={{ fontSize:'.76rem', lineHeight:1.4, color: script ? '#2E6B3A' : '#7a5b12' }}>
                        {script ? '✓ ' : '• '}<b>{item.name}</b>{script ? ` — prescribed by ${script.doctor}${script.date ? ' · ' + fmtD(script.date) : ''}` : ' — no matching prescription on file'}
                      </div>
                    ))}
                  </div>
                  <div style={{ fontSize:'.72rem', color: rxAllMatched ? '#3a6b44' : '#7a5b12', marginTop:8, lineHeight:1.5 }}>
                    {rxAllMatched
                      ? 'A licensed pharmacist will verify your prescription before dispatch.'
                      : 'By law these are dispensed only with a valid prescription, verified by our licensed pharmacy before dispatch.'}
                  </div>
                  {!rxAllMatched && (
                    <>
                      {rxUploaded ? (
                        <div style={{ marginTop:10, fontSize:'.8rem', fontWeight:700, color:'#2E6B3A' }}>✓ Prescription uploaded — a licensed pharmacist will verify it before dispatch.</div>
                      ) : (
                        <>
                          <div style={{ fontSize:'.78rem', color:'#7a5b12', marginTop:10, lineHeight:1.5 }}>Please <b>upload a valid prescription</b> from a registered doctor for the item(s) above to continue.</div>
                          <label style={{ display:'inline-flex', alignItems:'center', gap:8, marginTop:10, background:'#fff', border:`1.5px solid ${C.g600}`, borderRadius:10, padding:'.6rem 1rem', fontSize:'.82rem', fontWeight:700, color:C.g700, cursor: rxUploading ? 'default':'pointer' }}>
                            {rxUploading ? 'Uploading & reading…' : '📎 Upload prescription'}
                            <input type="file" accept="image/*" disabled={rxUploading} onChange={handleRxUpload} style={{ display:'none' }} />
                          </label>
                          <div style={{ marginTop:8 }}>
                            <span onClick={()=>navigate('/m/consult')} style={{ color:C.g700, fontWeight:700, fontSize:'.75rem', cursor:'pointer' }}>Don't have one? Consult a dermatologist →</span>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}
            </>
          )}
          {step === 1 && <AddressStep addr={addr} setAddr={setAddr}
            addresses={addresses} selectedId={selectedAddrId} editing={editingAddr} saving={savingAddr}
            onSelect={selectAddress} onNew={newAddress} onEdit={editAddress} onDelete={deleteAddress} onSave={saveAddress} onCancel={cancelEdit} />}
          {step === 2 && <PaymentStep payMethod={payMethod} setPayMethod={setPayMethod} />}

          {/* Navigation — inline on desktop, fixed bottom bar on mobile */}
          <div style={ narrow
            ? { position:'fixed', bottom:0, left:0, right:0, zIndex:40, background:'#fff', borderTop:`1px solid ${C.border}`, padding:'.7rem 1.1rem 1.3rem', display:'flex', alignItems:'center', gap:10 }
            : { display:'flex', justifyContent:'space-between', marginTop:'2rem', paddingTop:'1.5rem', borderTop:`1px solid ${C.border}` } }>
            {step > 0
              ? <button onClick={() => setStep(s => s-1)} style={{ padding: narrow ? '.9rem 1.1rem' : '.75rem 1.5rem', borderRadius: narrow ? 14 : 10, background:'white', color:C.g900, border:`1.5px solid ${C.border}`, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontSize:'.875rem', flexShrink:0 }}>{narrow ? '‹' : '← Back'}</button>
              : (!narrow && <div />)}
            {/* Mobile: show running total in the bar (summary is hidden until Payment) */}
            {narrow && step < 2 && (
              <div style={{ flexShrink:0, lineHeight:1.1 }}>
                <div style={{ fontSize:'.6rem', color:C.muted, textTransform:'uppercase', letterSpacing:'.05em' }}>Total</div>
                <div style={{ fontWeight:800, fontSize:'1rem', color:C.g900 }}>₹{total}</div>
              </div>
            )}
            {step < 2
              ? <button onClick={() => setStep(s => s+1)} disabled={!canProceed}
                  style={{ flex: narrow ? 1 : 'initial', padding: narrow ? '.95rem' : '.75rem 2rem', borderRadius: narrow ? 14 : 10, background: canProceed ? C.g700 : '#D1D5DB', color:'white', border:'none', fontWeight:800, cursor: canProceed ? 'pointer' : 'not-allowed', fontFamily:"'DM Sans',sans-serif", fontSize:'.9rem', letterSpacing:'.02em' }}>
                  Continue →
                </button>
              : <button onClick={confirmOrder} disabled={processing}
                  style={{ flex: narrow ? 1 : 'initial', padding: narrow ? '.95rem' : '.75rem 2rem', borderRadius: narrow ? 14 : 10, background: processing ? '#D1D5DB' : C.g700, color:'white', border:'none', fontWeight:800, cursor: processing ? 'not-allowed' : 'pointer', fontFamily:"'DM Sans',sans-serif", fontSize:'.9rem', letterSpacing:'.02em', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
                  {processing
                    ? <><span style={{ width:16, height:16, border:'2px solid rgba(255,255,255,.4)', borderTopColor:'white', borderRadius:'50%', animation:'spin 1s linear infinite', display:'inline-block' }} /> Opening Razorpay…</>
                    : <>Pay ₹{total}</>}
                </button>}
          </div>
        </div>

        {/* Right: Order Summary — on mobile only show it at the Payment step (cart already lists items) */}
        {(!narrow || step === 2) && (
        <div style={{ background:'white', borderRadius:14, border:`1px solid ${C.border}`, padding:'1.5rem', position: narrow ? 'static' : 'sticky', top:80 }}>
          <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.1rem', color:C.g900, marginBottom:'1.25rem' }}>Order Summary</h3>

          {cart.map((it, i) => (
            <div key={i} style={{ display:'flex', gap:'.75rem', alignItems:'center', paddingBottom:'.85rem', marginBottom:'.85rem', borderBottom:`1px solid ${C.border}` }}>
              <div style={{ width:48, height:48, background:'#f7f7f7', borderRadius:8, overflow:'hidden', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
                {it.imgs?.[0] ? <img src={cld(it.imgs[0], 120)} alt="" style={{ width:'100%', height:'100%', objectFit:'contain', padding:3 }} /> : <span style={{ opacity:.2 }}>🧴</span>}
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:'.78rem', fontWeight:600, color:C.g900, lineHeight:1.3 }}>{it.name}</div>
                <div style={{ fontSize:'.7rem', color:C.muted }}>Qty: {it.quantity||1}</div>
              </div>
              <div style={{ fontSize:'.85rem', fontWeight:600, color:C.g900 }}>₹{(it.price||0)*(it.quantity||1)}</div>
            </div>
          ))}

          <div style={{ display:'flex', flexDirection:'column', gap:'.6rem', fontSize:'.85rem' }}>
            <div style={{ display:'flex', justifyContent:'space-between', color:C.muted }}>
              <span>Subtotal</span><span>₹{subtotal}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', color: shipping === 0 ? C.g600 : C.muted }}>
              <span>Shipping</span><span>{shipping === 0 ? 'Free ✓' : `₹${shipping}`}</span>
            </div>
            {couponApplied && (
              <div style={{ display:'flex', justifyContent:'space-between', color:'#10B981' }}>
                <span>Coupon (REVIVE10)</span><span>−₹{discount}</span>
              </div>
            )}
            <div style={{ display:'flex', justifyContent:'space-between', fontWeight:700, color:C.g900, fontSize:'1rem', paddingTop:'.75rem', borderTop:`1px solid ${C.border}`, marginTop:'.25rem' }}>
              <span>Total</span><span>₹{total}</span>
            </div>
          </div>

          {shipping > 0 && (
            <div style={{ marginTop:'1rem', background:C.g50, border:`1px dashed ${C.g400}`, borderRadius:8, padding:'.65rem .9rem', fontSize:'.75rem', color:C.g700 }}>
              Add ₹{499 - subtotal} more for free shipping 🚚
            </div>
          )}

          <div style={{ marginTop:'1rem', display:'flex', flexDirection:'column', gap:'.4rem' }}>
            {[['🔒','100% secure payments'],['↩️','7-day easy returns']].map(([icon, text]) => (
              <div key={text} style={{ display:'flex', alignItems:'center', gap:6, fontSize:'.72rem', color:C.muted }}>
                <span>{icon}</span><span>{text}</span>
              </div>
            ))}
          </div>
        </div>
        )}
      </div>
    </div>
  )
}
